export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./contacts.vue?vue&type=template&id=f3e55d9e&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/contacts.vue?vue&type=template&id=f3e55d9e&
// module id = 1343
// module chunks = 0